import axios from 'axios'

//changed : baseURL: 'http://m1.test.mar.tv/tickets'

const axiosInstance = axios.create({
    baseURL: 'http://crm.test.mar.tv:81/api',
    // baseURL: 'http://10.10.11.160:8000/api',
    timeout: 15000,
    headers: {
        "Content-Type": 'application/json',
        'Accept': 'application/json'
    }
});

axiosInstance.interceptors.request.use( config =>  {
    const token = localStorage.token;
    if(token){
        config.headers.Authorization =  'Bearer ' + token;
    }
    return config;
});

// axiosInstance.interceptors.response.use(response => {
//     return response;
//   }, error => {
//     if(error.response.status === 401){
//         localStorage.removeItem('token');
//     }
//     return Promise.reject(error);
// });

export default axiosInstance;


